import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { deleteToken,gettokenlistburn,getBidslist,getAllcategory , deletecategory ,BurnField} from './../../actions/users';
import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import customInputStyle from "assets/jss/material-dashboard-react/components/customInputStyle.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { Link, useHistory } from "react-router-dom";
import EditIcon from '@material-ui/icons/Edit';
import { toastAlert } from '../../lib/toastAlert'
import CardHeader from "components/Card/CardHeader.js";
import * as moment from "moment";
import WhatshotIcon from '@material-ui/icons/Whatshot'; 
import config from "../../actions/config.js"  
import Web3 from 'web3';
import '@metamask/legacy-web3'
import { toast } from 'react-toastify';
import single from '../../ABI/ABI.json';
import multiple from '../../ABI/MULTIABI.json';
toast.configure();
let toasterOption = config.toasterOption;

// function createData(FirstName, lastName, Email, phoneNo, accountType) {
//   return { FirstName, lastName, Email, phoneNo, accountType };
// }

const rows = [
    // getData('')
    //   createData('firstName', 'lastName', 'Email', 'phoneNo', 'accountType')
    //   createData('Donut', 452, 25.0, 51, 4.9),
];

function stableSort(array, comparator) {
      console.log(array,'array')
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'category', numeric: false, disablePadding: true, label: 'Token Id' },
     { id: 'category', numeric: false, disablePadding: true, label: 'Token Owner' },
      { id: 'category', numeric: false, disablePadding: true, label: 'Balance' },
    { id: 'link', numeric: false, disablePadding: true, label: 'Link' },  
    { id: 'bidaddress', numeric: true, disablePadding: false, label: 'Date' },
    { id: 'tokendate', numeric: true, disablePadding: false, label: 'Action' },


];

function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 76%',
    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onChangeterm: PropTypes.func.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));


const customStyle = makeStyles(customInputStyle);

export default function EnhancedTable() {
    const classes = useStyles();
    const customStyles = customStyle();

    const classesSearch = useToolbarStyles();
    const [data, setData] = React.useState(0);
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [userDetails, setUser] = useState([]);
    const [searchQuery, setSearchQuery] = React.useState("");
    const [typingTimeout, setTypingTimeout] = useState(0)
    const [order, setOrder] = React.useState('asc');
    const [Burndata,setBurndata] = useState([]) 
    const [burnLoading, setBurnLoading]= React.useState(1); 
    const [MyTokenDetail,setMyTokenDetail] = useState([])

    function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
  }

    function editR(id) 
    {
        if(id!='') {
            window.location="/dfxethnftniarus/TokenView/"+id;
        }
        
    }
    function lock(){

    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        const self = this;
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        setSearchQuery(value)
        setTypingTimeout(setTimeout(function () {
            getAll({ 'search': value });
        }, 1000))
    }

    const handleRequestSort = (event, property) => {
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    useEffect(() => {
        getAll();
    }, [])
    const getAll = async (search = {}) => {
        let filterData = search;
        if (filterData.search == '') {
            filterData = {}
        }

        var test = await gettokenlistburn();
        console.log("tokenlistt",test.result)
        if(test && test.result){
          setUser(test.result);
        }
    }


    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleDelete = async (iid) => {
        try {
            var data={
                id:iid
            }
            const res = await deleteToken(iid);
            console.log(res,"===ress=============================")
            toastAlert('success', res.userValue.data.message, 'currency')
            getAll();
        } catch (err) { }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;

    async function FormSubmit(item,Burntoken){  
      var networkVersion = config.network
      setBurnLoading('processing');  
      if (window.ethereum) { 
      var web3 = new Web3(window.ethereum);  
      try {  
        if (typeof web3 !== 'undefined') { 
        window.ethereum.enable().then(async function() { 
        const web3  = new Web3(window.web3.currentProvider)  
        if (window.web3.currentProvider.isMetaMask === true) { 
          await web3.eth.getAccounts(async function(error, result) { 
           if(window.web3.currentProvider.networkVersion == networkVersion){ 
               var logaddress =result[0];  
               const singleContract = new web3.eth.Contract(single, config.singlesmartContract); 
               const multipleContract = new web3.eth.Contract(multiple, config.multiplesmartContract);  
               var CoursetroContract = item.type == 721 ? singleContract : multipleContract  
               var owner = await CoursetroContract.methods.owner().call(); 
               if(owner==logaddress){  
               if(item.type == 721){ 
                console.log(item.tokenCounts,"================beforeburn")
                CoursetroContract.methods  
                  .burn( 
                      item.tokenCounts,  
                  )  
                  .send({ from: logaddress })  
                  .then(async (result) => {  
                      setBurnLoading('done');  
                      var postData = { 
                        tokenOwner: item.tokenOwner, 
                        tokenCounts: item.tokenCounts, 
                        blockHash: result.blockHash, 
                        transactionHash: result.transactionHash, 
                        contractAddress:item.contractAddress,  
                        type:item.type,  
                        balance:item.balance,  
                        currAddr:item.tokenOwner,  
                        quant:item.balance 
                      }  
                      var updateBurnField = await BurnField(postData)  
                      if(updateBurnField){ 
                      toast.success('Burned successfully',toasterOption) 
                      document.getElementById('closeburn').click() 
                      window.location.reload();  
                      }  
                  }) 
                  .catch((error) => {  
                              setBurnLoading('try'); 
                              console.log('error : ', error);  
                              toast.error('Burn not placed', toasterOption)  
                          }) 
               }else{  
                  console.log(logaddress,  
                      item.tokenCounts,  
                      item.balance ,"================beforeburn")

                 CoursetroContract.methods 
                  .burn( 
                      logaddress,  
                      item.tokenCounts,  
                      item.balance 
                   ) 
                  .send({ from: logaddress })  
                  .then(async (result) => {  
                      setBurnLoading('done');  
                      console.log('result : ', result);  
                      var postData = { 
                        tokenOwner: item.tokenOwner, 
                        tokenCounts: item.tokenCounts, 
                        blockHash: result.blockHash, 
                        transactionHash: result.transactionHash, 
                        contractAddress:item.contractAddress,  
                        type:item.type,  
                        balance:item.balance,  
                        currAddr:item.tokenOwner,  
                        quant:item.balance 
                      }  
                      var updateBurnField = await BurnField(postData)  
                      if(updateBurnField){ 
                        toast.success('Burned successfully',toasterOption) 
                        document.getElementById('closeburn').click() 
                        window.location.reload();  
                      }  
                  }) 
                  .catch((error) => {  
                    setBurnLoading('try'); 
                    toast.error('Burn not placed', toasterOption)  
                  }) 
                  }  
                  }else{ 
                    setBurnLoading('try'); 
                    toast.error('Please Choose Admin Address to proceed ', toasterOption)  
                  }  
                 }else{  
                  setBurnLoading('try'); 
                   toast.error('Please Choose Mainnet', toasterOption) 
                 } 
                }) 
            }else{ 
              setBurnLoading('try'); 
               toast.error('Please Add Metamask External', toasterOption)  
            }  
          }) 
          }else{ 
              setBurnLoading('try'); 
               toast.error('Please Add Metamask External', toasterOption)  
            }  
        }catch(err){ 
          setBurnLoading('try'); 
          toast.error('Failed Try Again Later', toasterOption) 
        }  
      }else{ 
        setBurnLoading('try'); 
        toast.error('Please Add Metamask External', toasterOption) 
      }  
    } 

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Toolbar
                    className={clsx(classesSearch.root, {
                        [classesSearch.highlight]: selected.length > 0,
                    })}
                >
                    <Typography className={classesSearch.title} variant="h6" id="tableTitle" component="div">
                       Token List
                    </Typography>
                        {/* <div className={classes.flexHeader}>
                            <Link to={'/addcategory'} className={classes.btnPrimary}>Add Category</Link>
                        </div> */}
                    
                </Toolbar>
                <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            // size={dense ? 'small' : 'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                //   order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                            />
                            <TableBody>
                                 {stableSort(userDetails, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                  return (
                                        <TableRow>
                                            <TableCell align="center">{row.tokenCounts}</TableCell>
                                            <TableCell align="center">{row.tokenOwner}</TableCell>
                                            <TableCell align="center">{row.balance}</TableCell>
                                            <TableCell align="center"><a href={config.frontUrl+"art/"+row.tokenCounts}>Link</a></TableCell>
                                            <TableCell align="center">
                                                {moment(row.timestamp).format(
                                        "DD-MM-YYYY  h:mm a "
                                    )}
                                                </TableCell>
                                                <TableCell align="center">
                                                {burnLoading == "processing"? 
                                                <Link><WhatshotIcon  style={{ color: "#109ebf" }} /></Link>
                                                :
                                                <Link onClick={()=>FormSubmit(row,row)}><WhatshotIcon  style={{ color: "#109ebf" }} /></Link>
                                                }
                                                </TableCell>
                                        </TableRow>
                                    );
                                })
                                }

                            </TableBody>
                        </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={userDetails && userDetails.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    );
}